function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { getState } from '../analytics-state.js';
import { PIP_SUB_CONTENT, INTERACTION, COLLECTION } from '../constants.js';
export const mediaGallery = () => {
  const determineClickTarget = target => {
    if (target.match(/hotspots/i)) return 'hotspots';
    if (target.match(/image/i)) return 'image';
    if (target.match(/video/i)) return 'video';
    if (target.match(/threesixty/i)) return 'threesixty';
    if (target.match(/augmented_reality/i)) return 'ar';
    if (target.match(/customerImages/i)) return 'customerImages';
    return target;
  };
  window.LIFE_CYCLE_EVENT_BUS.on('media-gallery.click', _ref => {
    let {
      output = {}
    } = _ref;
    // perform ddo stuff for carousel click
    const {
      pageType = null
    } = getState() || {};
    const isCollection = pageType === COLLECTION;
    if (!isCollection) {
      const {
        target = '',
        section,
        component,
        position,
        guid
      } = output;
      const ddoEvent = {
        eventInfo: {
          eventName: PIP_SUB_CONTENT
        },
        category: {
          primaryCategory: INTERACTION
        },
        subContent: _objectSpread({
          section,
          component,
          target: determineClickTarget(target),
          position
        }, determineClickTarget(target) === 'image' && {
          guid
        })
      };
      digitalData.event.push(ddoEvent);
    }
  });
  window.LIFE_CYCLE_EVENT_BUS.on('media-gallery.thumbnail_click', _ref2 => {
    let {
      output
    } = _ref2;
    const {
      pageType = null
    } = getState() || {};
    const isCollection = pageType === COLLECTION;
    const {
      eventName,
      primaryCategory
    } = output;
    const thdAnalyticsEvent = {
      eventInfo: {
        eventName
      },
      category: {
        primaryCategory
      }
    };
    if (isCollection) {
      thdAnalyticsEvent.eventInfo.eventName = 'collection image';
    }
    digitalData.event.push(thdAnalyticsEvent);
  });
};
//# sourceMappingURL=media-gallery.listener.analytics.js.map